

export default function CenteredSectionCard({
        title, blurb, primaryButtonRow,
        primaryImageURL, primaryImageALT, secondaryImageURL, secondaryImageALT,
}) {

    return (
        <div>
            <div
                className="bg-gray-100 theme-dark bg-color bg-pattern-top bg-pattern-bottom bg-pattern _none mt-5 mb-5">
                <div className="container">
                    <div className="layout row layout-builder__layout">
                        <div className="col-12">
                            <div
                                className="text-center _none block block-layout-builder block-inline-blockbasic py-5">
                                <div className="basic-block-container">
                                    <div className="row align-items-stretch">
                                        {primaryImageURL &&
                                            <div
                                                className="col-3 position-relative d-none d-lg-block">
                                                <div className="left-image-container ">
                                                    <div>
                                                        <div
                                                            className="paragraph paragraph--type--fancy-image paragraph--view-mode--default image-angle-left image-no-border image-effects__floating">
                                                            <div>
                                                                <div
                                                                    className="view-mode-image_only">
                                                                    <div>
                                                                        <div>
                                                                            <img
                                                                                src={primaryImageURL}
                                                                                width="346"
                                                                                height="228"
                                                                                alt={primaryImageALT}
                                                                                loading="lazy"
                                                                                className="img-fluid"/>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        }
                                        <div className="col-12 col-lg basic-block-content space-y-4">
                                            <h2 className="fw-normal" style={{ fontSize: "clamp(1.5rem, 4vw, 3.75rem)" }}>{title}</h2>
                                            <div>
                                                <p>{blurb}</p>
                                            </div>
                                            <div>
                                                {primaryButtonRow}
                                            </div>
                                        </div>
                                        {
                                            secondaryImageURL &&
                                            <div className="col-12 col-lg-3 position-relative">
                                                <div className="right-image-container bottom">
                                                    <div>
                                                        <div
                                                            className="paragraph paragraph--type--fancy-image paragraph--view-mode--default image-angle-right image-show-border image-effects__floating">
                                                            <img
                                                                src={secondaryImageURL}
                                                                alt={secondaryImageALT}/>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        }
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}